import { Link } from "react-router-dom";
import React, { useEffect, Fragment } from "react";
import { Row } from "reactstrap";

const Paginations = ({ perPageData, totalNotes, currentPage, setCurrentPage, paginationDiv, paginationClass }) => {
    
    const totalPages = Math.max(1, Math.ceil(totalNotes / perPageData) || 1);

    const handleClick = (e) => {
        setCurrentPage(Number(e.target.id));
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    useEffect(() => {
        if (currentPage > totalPages) {
            setCurrentPage(totalPages);
        }
    }, [totalPages, currentPage, setCurrentPage]);

    return (
        <Fragment>
            <Row className="justify-content-between align-items-center">
                <div className={paginationDiv}>
                    <ul className={paginationClass}>
                        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                            <Link onClick={handlePrevPage} className="page-link" to="#">
                                <i className="mdi mdi-chevron-left"></i>
                            </Link>
                        </li>

                        {[...Array(totalPages)].map((_, index) => (
                            <li key={index + 1} className={`page-item ${currentPage === index + 1 ? "active" : ""}`}>
                                <Link onClick={handleClick} id={index + 1} className="page-link" to="#">
                                    {index + 1}
                                </Link>
                            </li>
                        ))}

                        <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                            <Link onClick={handleNextPage} className="page-link" to="#">
                                <i className="mdi mdi-chevron-right"></i>
                            </Link>
                        </li>
                    </ul>
                </div>
            </Row>
        </Fragment>
    );
};

export default Paginations;
